module.exports = __webpack_public_path__ + "img/jack_01.439d8316.png";